































































































































































































































































































































































import { Vue, Component, Watch, Ref } from 'vue-property-decorator'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import SeletorDeLojasDoUsuario from '@/components/loja/SeletorDeLojasDoUsuario.vue'
import { obrigatorio } from '@/shareds/regras-de-form'
import { FindCarrinhoUseCase } from '@/usecases/venda/FindCarrinhoUseCase'
import { ItemDoCarrinhoUseCase } from '@/usecases/venda/ItemDoCarrinhoUseCase'
import { Cliente, FormProdutoSimplesFilho, Fornecedor, ItemDaVenda, Loja, Pageable, PontoDeVenda, ProdutoFilho, UsuarioBase, Venda } from '@/models'
import type { Carrinho, ItemDoCarrinho } from '@/models/venda/Carrinho'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import CampoDeItemDeVenda from '@/components/venda/CampoDeItemDeVenda.vue'
import { DataOptions } from 'vuetify'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import { listasDeModalidadesDeFrete, obterUfDoEnderecoDaVenda, enderecoDaVendaEhDoMesmoEstadoDaLoja } from '@/shareds/venda-shareds'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import { FindFornecedorUseCase } from '@/usecases/fornecedor/FindFornecedorUseCase'
import SeletorDeFornecedor from '@/components/fornecedor/SeletorDeFornecedor.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import SeletorDeCliente from '@/views/application/clientes/SeletorDeCliente.vue'
import { FindProdutoUseCase } from '@/usecases/produto/FindProdutoUseCase'
import { FindConfiguracaoDaContaUseCase } from '@/usecases/conta/FindConfiguracaoDaContaUseCase'
import { converterProdutoParaProdutoSimples, obterQuantidadePesadaNaBalanca } from '@/shareds/produto-shareds'
import { FindPdvUseCase } from '@/usecases/pdv/FindPdvUseCase'
import { ImportarCarrinhoUseCase } from '@/usecases/carrinho/ImportarCarrinhoUseCase'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import { FinalizarVendaUseCase } from '@/usecases/venda/FinalizarVendaUseCase'
import { FindTurnoDeVendaUseCase, FindVendaUseCase } from '@/usecases'
import copy from 'copy-to-clipboard'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'


@Component({
	components: {
		BuscaDeProduto,
		SeletorDeLojasDoUsuario,
		CampoDeItemDeVenda,
		SeletorDeUsuario,
		SeletorDeFornecedor,
		CampoDecimal,
		SeletorDeCliente,
		Confirmacao,
		DialogoDeSelecionarVariante,
	},
})

export default class DialogoDeEdicaoDeCarrinho extends Vue {
	@Ref() readonly campoDeBusca!: CampoDeItemDeVenda
	@Ref() confirmacaoDePresencaNaEmissaoDaNota!: Confirmacao
	@Ref() confirmacaoDeCpfNaNota!: Confirmacao
	@Ref() confirmarEmissaoDeNE!: Confirmacao
	@Ref() dialogoDeSelecionarVariante!: DialogoDeSelecionarVariante

	itensDoCarrinho: ItemDoCarrinho[] = []
	pdvDoVendedor: PontoDeVenda | null = null
	listaDeFornecedores: Fornecedor[] = []
	cancelando: string[] = []

	buscandoFornecedores: boolean | null = null
	produto: ProdutoFilho | null = null
	dataFormatada: string | null = null
	carrinho: Carrinho | null = null
	busca: string | null = null
	erro: null | Error = null
	loja: Loja | null = null

	mostra = false
	salvando = false
	carregando = false
	editando = false
	faturando = false
	pesquisa = ''
	totalRegistros = -1
	listasDeModalidadesDeFrete = listasDeModalidadesDeFrete
	bucouTodasAsTransportadoras = false
	mostrarDialogoLeituraDeCodigoBarras = false
	showCamera = false
	valorLido: string | null = null
	buscandoProduto = false
	mostrarDialogoLeituraQrCode = false
	lendoQr = false
	carregandoItemNoCarrinho = false

	painelItensAberto: number | null = null

	findCarrinhoUseCase = new FindCarrinhoUseCase()
	itemDoCarrinhoUseCase = new ItemDoCarrinhoUseCase()
	findFornecedorUseCase = new FindFornecedorUseCase()
	findProdutoUseCase = new FindProdutoUseCase()
	findConfiguracaoDaContaUseCase = new FindConfiguracaoDaContaUseCase()
	findPdvUseCase = new FindPdvUseCase()
	importarCarrinhoUseCase = new ImportarCarrinhoUseCase()
	findTurnoDeVendaUseCase = new FindTurnoDeVendaUseCase()
	findVendaUseCase = new FindVendaUseCase()

	obrigatorio = obrigatorio
	copyToClipboard = copy
	AlertModule = AlertModule

	pageable: Pageable = {
		page: 0,
		size: 10,
	}

	tiposDoCarrinho = [
		{ text: 'Malinha', value: 'Malinha' },
		//{ text: 'Pedido', value: 'Pedido' },
	]

	headers = [
		{ text: 'Produto', value: 'produto.nome' },
		{ text: 'Sku', value: 'produto.sku' },
		{ text: 'Ean', value: 'produto.eans' },
		{ text: 'Quantidade', value: 'quantidade' },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center' },
	]

	readerSize = {
		width: 860,
		height: 480,
	}

	paginacao: DataOptions = {
		page: 1,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	async mostrar(editando: boolean, carrinho: Carrinho) {
		this.editando = editando
		this.carrinho = carrinho

		if (editando) {
			this.itensDoCarrinho = [...this.carrinho.itens]
			try {
				await this.buscarPdvDoVendedor()
			} catch {
				// abre o modal normalmente mesmo sem PDV
			}
		}

		this.mostra = true
	}

	fechar() {
		this.produto = null
		this.loja = null
		this.mostrarDialogoLeituraDeCodigoBarras = false
		this.showCamera = false
		this.itensDoCarrinho = []
		this.pesquisa = ''
		this.carregandoItemNoCarrinho = false
		this.mostra = false
	}

	async cancelar() {
		try {
			if (this.carrinho?.id && !this.editando) {
				await this.findCarrinhoUseCase.removerCarrinho(this.carrinho.id)
			} 
		} catch (e) {
			//
		} finally {
			this.fechar()
		}
	}

	get usuario() {
		return UserLoginStore.usuario
	}

	async salvar() {
		if (!this.carrinho) return
		if (!this.carrinho.loja) return AlertModule.setError("Obrigatório selecionar uma loja!")
		if (!this.carrinho.vendedor) return AlertModule.setError("Obrigatório selecionar um vendedor!")
		if (!this.carrinho.tipoDoCarrinho) return AlertModule.setError("Obrigatório selecionar o tipo do seu carrinho!")
		if (!this.carrinho.cliente) return AlertModule.setError("Obrigatório selecionar um cliente!")

		try {
			this.salvando = true
			this.carrinho.link = window.location.origin + this.$route.fullPath

			if (this.carrinho.id) {
				const carrinhoSalvo = await this.findCarrinhoUseCase.atualizarCarrinho(this.carrinho)
				this.$emit('atualizarLista', carrinhoSalvo.tipoDoCarrinho)
			} else {
				this.carrinho.link = window.location.origin + this.$route.fullPath
				const carrinhoBase = { ...this.carrinho, itens: [] }
				const carrinhoCriado = await this.findCarrinhoUseCase.criarCarrinho(carrinhoBase)
				this.$emit('atualizarLista', carrinhoCriado.tipoDoCarrinho)
			}

			AlertModule.setSuccess('Carrinho salvo com sucesso')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.produto = null
			this.loja = null
			this.salvando = false
			this.fechar()
		}
	}

	async atualizarListaDeProdutos(item: ItemDoCarrinho | ProdutoFilho) {
		if (!this.carrinho || !this.carrinho.loja) return
		if (!this.carrinho.vendedor) return AlertModule.setError("Necessário informar vendedor.")
		if (!this.carrinho.tipoDoCarrinho) return AlertModule.setError("Necessário informar tipo do carrinho.")
		if (!this.carrinho.cliente || typeof this.carrinho.cliente === 'string') return AlertModule.setError("Necessário informar Cliente.")

		this.carrinho.itens = this.carrinho.itens ?? []
		this.carregandoItemNoCarrinho = true

		try {
			let novoItem: ItemDoCarrinho

			if ((item as any).produto === undefined) {
				const produto = item as FormProdutoSimplesFilho
				novoItem = {
					id: '',
					produto,
					preco: 0,
					precoDeCusto: 0,
					quantidade: 1,
					valorFreteRateado: 0,
				} as ItemDoCarrinho
			} else {
				novoItem = item as ItemDoCarrinho
			}

			novoItem = await this.precificarItemDoCarrinho(novoItem)

			const existente = this.carrinho.itens.find(
				(i) => i.produto && i.produto.id === novoItem.produto.id,
			)

			if (existente) {
				existente.quantidade += novoItem.quantidade
				this.carrinho.valorTotal += (novoItem.preco || 0) * (novoItem.quantidade || 0)
			} else {
				this.carrinho.itens.push(novoItem)
				this.carrinho.valorTotal += (novoItem.preco || 0) * (novoItem.quantidade || 0)
			}

			this.carrinho.quantidadeDePecas = (this.carrinho.quantidadeDePecas || 0) + (novoItem.quantidade || 0)

			if (!this.carrinho.id) {
				this.carrinho.link = window.location.origin + this.$route.fullPath
				const carrinhoBase = { ...this.carrinho, itens: [] }
				const carrinhoCriado = await this.findCarrinhoUseCase.criarCarrinho(carrinhoBase)
				const valorTotalLocal = this.carrinho.valorTotal
				const quantidadeDePecasLocal = this.carrinho.quantidadeDePecas
				this.carrinho = {
					...carrinhoCriado,
					itens: this.carrinho.itens,
					valorTotal: valorTotalLocal,
					quantidadeDePecas: quantidadeDePecasLocal,
				}
			}

			const itemParaSalvar = existente ?? novoItem
			this.carrinho.movimentouEstoque = await this.itemDoCarrinhoUseCase.salvarOuAtualizarItemDoCarrinho(
				this.carrinho.id,
				itemParaSalvar,
			)

			if (this.editando) {
				await this.findCarrinhoUseCase.atualizarTotaisDoCarrinho(
					this.carrinho.id,
					this.carrinho.valorTotal,
					this.carrinho.quantidadeDePecas,
				)
			}

			this.itensDoCarrinho = [...this.carrinho.itens]
			this.painelItensAberto = 0
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoItemNoCarrinho = false
		}
	}

	async removerItemDoCarrinho(produtoId: string) {
		if (!this.carrinho || !this.carrinho.id) return

		const itemRemovido = this.carrinho.itens.find(
			(i) => i.produto.id === produtoId,
		)

		this.cancelando.push(produtoId)
		try {
			await this.itemDoCarrinhoUseCase.removerItemDoCarrinho(produtoId, this.carrinho.id)

			this.carrinho.itens = (this.carrinho.itens || []).filter(
				(i) => i.produto.id !== produtoId,
			)
			this.itensDoCarrinho = this.itensDoCarrinho.filter(
				(i) => i.produto.id !== produtoId,
			)

			if (itemRemovido) {
				this.carrinho.quantidadeDePecas = Math.max(0, (this.carrinho.quantidadeDePecas || 0) - (itemRemovido.quantidade || 1))
				this.carrinho.valorTotal = Math.max(0, (this.carrinho.valorTotal || 0) - (itemRemovido.preco || 0) * (itemRemovido.quantidade || 1))
			}

			if (this.editando) {
				await this.findCarrinhoUseCase.atualizarTotaisDoCarrinho(
					this.carrinho.id,
					this.carrinho.valorTotal,
					this.carrinho.quantidadeDePecas,
				)
			}

			AlertModule.setSuccess('Item removido do carrinho')
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.cancelando = this.cancelando.filter(id => id !== produtoId)
		}
	}

	@Watch('carrinho.informacoesDeTransporte.modalidadeDeFrete')
	onChangeModalidadeDeFrete() {
		this.listaDeFornecedores = []
		this.pageable.page = 0

		if (this.carrinho && this.carrinho.informacoesDeTransporte && this.carrinho.informacoesDeTransporte.modalidadeDeFrete === 'Sem Frete') {
			this.carrinho.informacoesDeTransporte.fornecedor = null
			this.carrinho.informacoesDeTransporte.pesoBruto = null
			this.carrinho.informacoesDeTransporte.pesoLiquido = null
			this.carrinho.informacoesDeTransporte.especie = null
			this.carrinho.informacoesDeTransporte.volume = null
			this.carrinho.informacoesDeTransporte.valorFrete = null

			return
		}

		this.buscarTransportadoras()
	}

	async buscarTransportadoras() {
		try {
			this.buscandoFornecedores = true

			const params = {
				tipoFornecedor: 'Transportadora',
				page: this.pageable.page ? this.pageable.page : 0,
				size: this.pageable.size,
				sort: this.pageable.sort,
				busca: this.busca,
			}

			const fornecedoresPage = await this.findFornecedorUseCase.find(params)

			if (!fornecedoresPage.last) {
				this.pageable.page = !this.pageable.page
					? 1
					: (this.pageable.page += 1)
				this.listaDeFornecedores.push(...fornecedoresPage.content)
				this.bucouTodasAsTransportadoras = false
			} else {
				this.listaDeFornecedores.push(...fornecedoresPage.content)
				this.bucouTodasAsTransportadoras = true
			}
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.buscandoFornecedores = false
		}
	}

	async buscarPdvDoVendedor() {
		if (!this.carrinho || !this.carrinho.loja || !this.carrinho.vendedor) return
		const pdv = await this.findPdvUseCase.findPdvDeDemonstracaoDoVendedor(this.carrinho.loja.id, this.carrinho.vendedor.id)
		this.pdvDoVendedor = pdv
	}

	async faturar(gerarCupom: boolean, emitirDanfe: boolean) {
		if (!this.carrinho || !this.carrinho.loja) return
		if (!this.carrinho.vendedor) return AlertModule.setError("Necessário informar vendedor.")
		if (!this.pdvDoVendedor) return AlertModule.setError("Validar se vendedor cadastrado possui Ponto de Venda de somente demonstração e consignado configurado.")

		const carrinhoId = this.carrinho.id

		if (!emitirDanfe){
			const confirma = await this.confirmarEmissaoDeNE.mostrar()
			if (!confirma) return
		}

		const desabilitarQuestionamentoIdDestContribuinte = this.carrinho.loja.configuracaoDaLoja.naoQuestionarIdDestParaContribuinte && this.carrinho.cliente?.inscricaoEstadual !== 'ISENTO'
		const usarIdDestPresencialParaClienteIsento = this.carrinho.loja.configuracaoDaLoja.usarIdDestPresencialParaClienteIsento && this.carrinho.cliente?.inscricaoEstadual === 'ISENTO'
		this.faturando = true
		let venda: Venda | null = null

		try {
			const turnoDeVenda = await this.findTurnoDeVendaUseCase.validaTurnoDeVendaCarrinho(this.pdvDoVendedor.id)
			venda = await this.importarCarrinhoUseCase.importarCarrinho(this.carrinho, turnoDeVenda)
			let vendedoresDaVenda: UsuarioBase[] | null = null
			let clienteDaVenda: Cliente | null = null

			const ufLoja = this.carrinho.loja.endereco.uf
			const ufCliente = obterUfDoEnderecoDaVenda(venda)
			const isForaDoEstado = ufLoja !== ufCliente
			const isMesmoEstado = enderecoDaVendaEhDoMesmoEstadoDaLoja(venda, ufLoja)

			if (isForaDoEstado && !this.carrinho.loja.configuracaoDaLoja.permitirCriarNotaDeDemonstracaoParaForaDoEstado && emitirDanfe) {
				AlertModule.setError("UF da loja e UF do cliente são diferentes. <br>" +
				"Notas de demonstração não podem ser criadas para outros estados.<br> " +
				"Para prosseguir, altere as configurações de loja.")
				return
			}

			if (emitirDanfe){
				venda.isOperacaoPresencial = desabilitarQuestionamentoIdDestContribuinte
					? !isForaDoEstado
					: (usarIdDestPresencialParaClienteIsento || isMesmoEstado)
						? true
						: !(await this.confirmacaoDePresencaNaEmissaoDaNota.mostrar())
			}

			clienteDaVenda = venda.cliente
			vendedoresDaVenda = venda.vendedor

			VendaModule.setEtapaVenda({ estado: 'SEM_PROCESSO', vendas: [] })
			venda = await FinalizarVendaUseCase({
				venda: venda,
				turnoDeVenda: turnoDeVenda,
				gerarCupom,
				detalhesDosPagamentos: [],
				itensDevolucao: [],
				emitirDanfe,
			})

			const possuiTelefoneDoCliente = clienteDaVenda && clienteDaVenda.telefones.length > 0 ? true : false
			const possuiVendedor = vendedoresDaVenda && vendedoresDaVenda.length > 0 ? true : false

			if (possuiTelefoneDoCliente && possuiVendedor && venda.pontoDeVenda?.loja.configuracaoDaLoja?.utilizarAvaliacaoNps && venda.identificador){
				const link = window.location.origin + this.$route.fullPath.replace(/^\/caixa/, '')
				await this.findVendaUseCase.gerarLinkDeAvaliacaoNps(venda.identificador, link)
			}

			const carrinhoAtualizado = await this.findCarrinhoUseCase.relacionarVendaAoCarrinho(venda.id, carrinhoId)
			this.carrinho = carrinhoAtualizado
			this.$emit('atualizarMalinhas', carrinhoAtualizado)

		} catch (error: any) {
			AlertModule.setError("Erro ao faturar nota fiscal. Contate o suporte.")
			if (venda?.id && carrinhoId) {
				try {
					const carrinhoAtualizado = await this.findCarrinhoUseCase.relacionarVendaAoCarrinho(venda.id, carrinhoId)
					this.carrinho = carrinhoAtualizado
					this.$emit('atualizarMalinhas', carrinhoAtualizado)
				} catch {
					// ignora erro do relacionamento para não sobrescrever o erro original
				}
			}
		} finally {
			this.faturando = false
		}
	}

	async irParaVendaOrigem(carrinho: Carrinho | null){
		if (!carrinho || !carrinho.venda) return
		if (this.temRecurso('ler', 'vendas')) {
			window.open(`/vendas?identificador=${carrinho.venda.identificador}`, '_blank')
		}
	}

	get temRecurso() {
		return UserLoginStore.temAutorizacaoPorOperacaoERecurso
	}

	async processarCodigoLido(codigo: string) {
		if (!this.carrinho || !this.carrinho.loja) return

		this.buscandoProduto = true

		try {
			const produto = await this.findProdutoUseCase.findProdutoPorIdentificador(codigo)

			if (produto.tipo === 'Com Variantes') {
				this.dialogoDeSelecionarVariante &&
				this.dialogoDeSelecionarVariante.abrir(Promise.resolve(produto))
				this.buscandoProduto = false
				return
			}

			const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

			const quantidadeDeItens =
        produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT' ? 1 : obterQuantidadePesadaNaBalanca('',
              configuracaoDeConta?.medida || 6,
              configuracaoDeConta?.eans || 7,
              configuracaoDeConta?.casasNumericas || 4,
        )

			const item: ItemDoCarrinho = {
				id: '',
				produto: converterProdutoParaProdutoSimples(produto),
				preco: 0,
				precoDeCusto: 0,
				quantidade: quantidadeDeItens,
				valorFreteRateado: 0,
			}

			await this.atualizarListaDeProdutos(item)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscandoProduto = false
		}
	}

	async adicionarVarianteAoCarrinho(produto: ProdutoFilho | null) {
		if (!produto) return

		this.buscandoProduto = true

		try {
			const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()

			const quantidadeDeItens =
				produto.unidadeDeMedida !== 'KG' && produto.unidadeDeMedida !== 'MT' ? 1 : obterQuantidadePesadaNaBalanca('',
					configuracaoDeConta?.medida || 6,
					configuracaoDeConta?.eans || 7,
					configuracaoDeConta?.casasNumericas || 4,
				)

			const item: ItemDoCarrinho = {
				id: '',
				produto: converterProdutoParaProdutoSimples(produto),
				preco: 0,
				precoDeCusto: 0,
				quantidade: quantidadeDeItens,
				valorFreteRateado: 0,
			}

			await this.atualizarListaDeProdutos(item)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.buscandoProduto = false
		}
	}

	beep() {
		const audio = document.querySelector('audio')
		if (!audio) return
		audio.play()
	}

	async logIt(data: any) {
		const codigo = data?.codeResult?.code
		if (!codigo) return

		this.showCamera = false
		this.beep()

		await this.processarCodigoLido(codigo)

		this.showCamera = true
	}

	abrirLeitorQr() {
		this.mostrarDialogoLeituraQrCode = true
	}

	fecharLeitorQr() {
		this.mostrarDialogoLeituraQrCode = false
	}

	async onQrInit(promise: Promise<void>) {
		this.lendoQr = true
		try {
			await promise
		} catch (error) {
			this.$emit('erro', error)
			this.fecharLeitorQr()
		} finally {
			this.lendoQr = false
		}
	}

	async onQrDecode(conteudo: string) {
		this.beep()

		try {
			const configuracaoDeConta = await this.findConfiguracaoDaContaUseCase.find()
			const urlQrCode = configuracaoDeConta.urlQrCode

			if (urlQrCode) {
				const semProtocolo = conteudo.replace(/^https?:\/\//, '')
				const urlSemProtocolo = urlQrCode.replace(/^https?:\/\//, '')
				if (semProtocolo.startsWith(urlSemProtocolo)) {
					conteudo = semProtocolo.substring(urlSemProtocolo.length)
				}
			}

			conteudo = conteudo.replace(/\D+/g, '')

			if (conteudo.length < 10) {
				conteudo = conteudo.padStart(10, '0')
			}

			if (conteudo.length >= 5) {
				conteudo = `${conteudo.slice(0, 3)}.${conteudo.slice(3, 5)}.${conteudo.slice(5)}`
			}

			await this.processarCodigoLido(conteudo)

		} finally{
			this.fecharLeitorQr()
		}
	}

	async precificarItemDoCarrinho(item: ItemDoCarrinho): Promise<ItemDoCarrinho> {
		if (!this.carrinho || !this.carrinho.loja || !this.carrinho.cliente) return item

		const tipoDeCliente = this.carrinho.cliente.tipoDeCliente ? this.carrinho.cliente.tipoDeCliente.nome : null

		const vendaAtual = {
			loja: this.carrinho.loja,
			cpfDoCliente: this.carrinho.cliente.cnpjOuCpf,
			itens: [],
			isConsignado: false,
			isDemonstracao: true,
			isVendaReaberta: false,
			tipoDeTransacao: null,
			tipoNota: null,
		} as unknown as Venda

		const itemDaVenda = {
			produto: item.produto,
			quantidade: item.quantidade,
			preco: item.preco,
			precoDeCusto: item.precoDeCusto,
			desconto: (item as any).desconto ?? { isPercentual: false, valor: 0 },
		} as unknown as ItemDaVenda

		const [itemComPreco] = await AplicarTabelaDePrecoUseCase({
			loja: this.carrinho.loja,
			itens: [itemDaVenda],
			tipoDeCliente,
			vendaAtual,
			validarLimiteDeProduto: false, 
		})

		return {
			...item,
			preco: itemComPreco.preco || 0,
			precoDeCusto: (itemComPreco as any).precoDeCusto || 0,
		}
	}

}

